import PurchaseSummary from 'components/payment/PurchaseSummary';
import styled from 'styled-components';

export const StyledPurchaseSummary = styled(PurchaseSummary)`
  width: 100%;
  margin-bottom: 30px;
`;
